import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const BackTitle = styled.div`
  font-size: 18px;
  color: ${myPalette.white.main};
`
